module.exports = __webpack_public_path__ + "img/bg1.39a22cf8.png";